import { __read } from "tslib";
import { domIOSystem } from './domIOSystem';
import { initialTopMostItemIndexSystem } from './initialTopMostItemIndexSystem';
import { propsReadySystem } from './propsReadySystem';
import { sizeSystem, sizeTreeToRanges } from './sizeSystem';
import * as u from './urx';
import { windowScrollerSystem } from './windowScrollerSystem';
export var stateLoadSystem = u.system(function (_a) {
    var _b = __read(_a, 5), _c = _b[0], sizes = _c.sizes, sizeRanges = _c.sizeRanges, scrollTop = _b[1].scrollTop, initialTopMostItemIndex = _b[2].initialTopMostItemIndex, didMount = _b[3].didMount, _d = _b[4], useWindowScroll = _d.useWindowScroll, windowScrollContainerState = _d.windowScrollContainerState, windowViewportRect = _d.windowViewportRect;
    var getState = u.stream();
    var restoreStateFrom = u.statefulStream(undefined);
    var statefulWindowScrollContainerState = u.statefulStream(null);
    var statefulWindowViewportRect = u.statefulStream(null);
    u.connect(windowScrollContainerState, statefulWindowScrollContainerState);
    u.connect(windowViewportRect, statefulWindowViewportRect);
    u.subscribe(u.pipe(getState, u.withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect)), function (_a) {
        var _b = __read(_a, 6), callback = _b[0], sizes = _b[1], scrollTop = _b[2], useWindowScroll = _b[3], windowScrollContainerState = _b[4], windowViewportRect = _b[5];
        var ranges = sizeTreeToRanges(sizes.sizeTree);
        if (useWindowScroll && windowScrollContainerState !== null && windowViewportRect !== null) {
            scrollTop = windowScrollContainerState.scrollTop - windowViewportRect.offsetTop;
        }
        callback({ ranges: ranges, scrollTop: scrollTop });
    });
    u.connect(u.pipe(restoreStateFrom, u.filter(u.isDefined), u.map(locationFromSnapshot)), initialTopMostItemIndex);
    u.connect(u.pipe(didMount, u.withLatestFrom(restoreStateFrom), u.filter(function (_a) {
        var _b = __read(_a, 2), state = _b[1];
        return state !== undefined;
    }), u.distinctUntilChanged(), u.map(function (_a) {
        var _b = __read(_a, 2), snapshot = _b[1];
        return snapshot.ranges;
    })), sizeRanges);
    return {
        getState: getState,
        restoreStateFrom: restoreStateFrom,
    };
}, u.tup(sizeSystem, domIOSystem, initialTopMostItemIndexSystem, propsReadySystem, windowScrollerSystem));
function locationFromSnapshot(snapshot) {
    return { offset: snapshot.scrollTop, index: 0, align: 'start' };
}
